"use strict"; // This software is released under the MIT License.
// https://opensource.org/licenses/MIT

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.protoPerialize = exports.validators = exports.nodeInteraction = exports.seedUtils = exports.libs = void 0;

var mass_transfer_1 = require("./transactions/mass-transfer");

Object.defineProperty(exports, "massTransfer", {
  enumerable: true,
  get: function get() {
    return mass_transfer_1.massTransfer;
  }
});

var reissue_1 = require("./transactions/reissue");

Object.defineProperty(exports, "reissue", {
  enumerable: true,
  get: function get() {
    return reissue_1.reissue;
  }
});

var burn_1 = require("./transactions/burn");

Object.defineProperty(exports, "burn", {
  enumerable: true,
  get: function get() {
    return burn_1.burn;
  }
});

var exchange_1 = require("./transactions/exchange");

Object.defineProperty(exports, "exchange", {
  enumerable: true,
  get: function get() {
    return exchange_1.exchange;
  }
});

var lease_1 = require("./transactions/lease");

Object.defineProperty(exports, "lease", {
  enumerable: true,
  get: function get() {
    return lease_1.lease;
  }
});

var cancel_lease_1 = require("./transactions/cancel-lease");

Object.defineProperty(exports, "cancelLease", {
  enumerable: true,
  get: function get() {
    return cancel_lease_1.cancelLease;
  }
});

var data_1 = require("./transactions/data");

Object.defineProperty(exports, "data", {
  enumerable: true,
  get: function get() {
    return data_1.data;
  }
});

var issue_1 = require("./transactions/issue");

Object.defineProperty(exports, "issue", {
  enumerable: true,
  get: function get() {
    return issue_1.issue;
  }
});

var transfer_1 = require("./transactions/transfer");

Object.defineProperty(exports, "transfer", {
  enumerable: true,
  get: function get() {
    return transfer_1.transfer;
  }
});

var alias_1 = require("./transactions/alias");

Object.defineProperty(exports, "alias", {
  enumerable: true,
  get: function get() {
    return alias_1.alias;
  }
});

var set_script_1 = require("./transactions/set-script");

Object.defineProperty(exports, "setScript", {
  enumerable: true,
  get: function get() {
    return set_script_1.setScript;
  }
});

var set_asset_script_1 = require("./transactions/set-asset-script");

Object.defineProperty(exports, "setAssetScript", {
  enumerable: true,
  get: function get() {
    return set_asset_script_1.setAssetScript;
  }
});

var sponsorship_1 = require("./transactions/sponsorship");

Object.defineProperty(exports, "sponsorship", {
  enumerable: true,
  get: function get() {
    return sponsorship_1.sponsorship;
  }
});

var order_1 = require("./requests/order");

Object.defineProperty(exports, "order", {
  enumerable: true,
  get: function get() {
    return order_1.order;
  }
});

var cancel_order_1 = require("./requests/cancel-order");

Object.defineProperty(exports, "cancelOrder", {
  enumerable: true,
  get: function get() {
    return cancel_order_1.cancelOrder;
  }
});

var custom_data_1 = require("./requests/custom-data");

Object.defineProperty(exports, "customData", {
  enumerable: true,
  get: function get() {
    return custom_data_1.customData;
  }
});
Object.defineProperty(exports, "serializeCustomData", {
  enumerable: true,
  get: function get() {
    return custom_data_1.serializeCustomData;
  }
});

var auth_1 = require("./requests/auth");

Object.defineProperty(exports, "auth", {
  enumerable: true,
  get: function get() {
    return auth_1.auth;
  }
});

var wavesAuth_1 = require("./requests/wavesAuth");

Object.defineProperty(exports, "wavesAuth", {
  enumerable: true,
  get: function get() {
    return wavesAuth_1.wavesAuth;
  }
});

var invoke_script_1 = require("./transactions/invoke-script");

Object.defineProperty(exports, "invokeScript", {
  enumerable: true,
  get: function get() {
    return invoke_script_1.invokeScript;
  }
});

var update_asset_info_1 = require("./transactions/update-asset-info");

Object.defineProperty(exports, "updateAssetInfo", {
  enumerable: true,
  get: function get() {
    return update_asset_info_1.updateAssetInfo;
  }
});

var general_1 = require("./general");

Object.defineProperty(exports, "signTx", {
  enumerable: true,
  get: function get() {
    return general_1.signTx;
  }
});
Object.defineProperty(exports, "verify", {
  enumerable: true,
  get: function get() {
    return general_1.verify;
  }
});
Object.defineProperty(exports, "serialize", {
  enumerable: true,
  get: function get() {
    return general_1.serialize;
  }
});
Object.defineProperty(exports, "submitOrder", {
  enumerable: true,
  get: function get() {
    return general_1.submitOrder;
  }
});
Object.defineProperty(exports, "cancelSubmittedOrder", {
  enumerable: true,
  get: function get() {
    return general_1.cancelSubmittedOrder;
  }
});
Object.defineProperty(exports, "verifyAuthData", {
  enumerable: true,
  get: function get() {
    return general_1.verifyAuthData;
  }
});
Object.defineProperty(exports, "verifyCustomData", {
  enumerable: true,
  get: function get() {
    return general_1.verifyCustomData;
  }
});
Object.defineProperty(exports, "verifyWavesAuthData", {
  enumerable: true,
  get: function get() {
    return general_1.verifyWavesAuthData;
  }
});

var nodeInteraction_1 = require("./nodeInteraction");

Object.defineProperty(exports, "waitForTx", {
  enumerable: true,
  get: function get() {
    return nodeInteraction_1.waitForTx;
  }
});
Object.defineProperty(exports, "broadcast", {
  enumerable: true,
  get: function get() {
    return nodeInteraction_1.broadcast;
  }
});

var make_tx_1 = require("./make-tx");

Object.defineProperty(exports, "makeTx", {
  enumerable: true,
  get: function get() {
    return make_tx_1.makeTx;
  }
});
Object.defineProperty(exports, "makeTxBytes", {
  enumerable: true,
  get: function get() {
    return make_tx_1.makeTxBytes;
  }
}); // internal libraries access

var crypto = __importStar(require("@waves/ts-lib-crypto"));

var marshall = __importStar(require("@waves/marshall")); // import * as nodeApiJs from '@waves/node-api-js'


var libs = {
  crypto: crypto,
  marshall: marshall
};
exports.libs = libs;

var seedUtils = __importStar(require("./seedUtils"));

exports.seedUtils = seedUtils;

var nodeInteraction = __importStar(require("./nodeInteraction"));

exports.nodeInteraction = nodeInteraction;

var validators = __importStar(require("./validators"));

exports.validators = validators;

var protoPerialize = __importStar(require("./proto-serialize"));

exports.protoPerialize = protoPerialize;